import * as React from 'react'
import { Redirect } from 'react-router-dom'
import connect from 'react-redux/es/connect/connect'
import { clearAuthFailure } from 'actions/Auth'
import AppMainContainer from './AppMainContainer'
import LoginContainer from './LoginContainer'
import IntlMessages, { toParagraphs } from 'util/IntlMessages'
import { Button } from 'reactstrap'
import debug from 'debug'

const authFailDebug = debug('linkgua:auth:failure')

class AuthFailure extends React.Component {

  constructor (props, context) {
    super(props, context)
    authFailDebug('<init>', props)

    // store message on instance and clear in store, to make it disappear on reload
    const { authenticationFailure, clearAuthFailure } = this.props
    this.authenticationFailure = authenticationFailure
    clearAuthFailure()
  }

  render () {
    authFailDebug('render', this.authenticationFailure)

    const { history, loginHash } = this.props

    if (loginHash) {
      return (<Redirect to='/' />)
    }

    // explicitly render message stored on instance and not from store, because it is cleared from store on first render
    const message = this.authenticationFailure ? this.authenticationFailure : 'Unknown authentication error happened'

    return (
      <AppMainContainer>
        <LoginContainer>
          <div>
            <div className="mb-4"><h2><span><IntlMessages id='authError.message'/></span></h2></div>
            <div>
              <span>
                <IntlMessages id='authError.description'>{toParagraphs}</IntlMessages>
              </span>
            </div>
            <div><p/></div>
            <div className="mb-4">
              <Button className="text-uppercase btn-success" onClick={() => history.push('/signout?returnTo=/signin')}><IntlMessages id='authError.loginBtnLabel'/></Button>
            </div>
            <div><p/></div>
            <div><span className='small'>({message})</span></div>
          </div>
        </LoginContainer>
      </AppMainContainer>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const { authenticationFailure, loginHash } = auth
  return { authenticationFailure, loginHash }
}

export default connect(mapStateToProps, { clearAuthFailure })(AuthFailure)



// WEBPACK FOOTER //
// ./Linkgua/containers/AuthFailure.js